import { render, staticRenderFns } from "./NewsNew.vue?vue&type=template&id=2c2b8e7c&scoped=true&"
import script from "./NewsNew.vue?vue&type=script&lang=js&"
export * from "./NewsNew.vue?vue&type=script&lang=js&"
import style0 from "./NewsNew.vue?vue&type=style&index=0&id=2c2b8e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b8e7c",
  null
  
)

export default component.exports